import { SYSLogin } from "../features/sys/login/allactions"
import { SYSShellbar } from "../features/sys/shellbar/allactions"
import { SYSUserAdministration } from "../features/sys/useradministration/allactions"

import { DATFeedback } from "../features/datdocuments/feedback/allactions"
import { DATSearchPaket } from "../features/datdocuments/searchpaket/allactions"

import { PKGPackaging } from "../features/pkgpackaging/packaging/allactions"

import { QUTBPFilter } from "../components/bpfilter/allactions"
import { QUTOffering } from "../features/qutoffering/offering/allactions"
import { QUTOfferingPos } from "../features/qutoffering/offering/cut/poslist/allactions"
import { QUTOfferingAdminUpload } from "../features/qutoffering/offering/adminupload/allactions"
import { QUTOfferingDetails } from "../features/qutoffering/offering/details/allactions"
import { QUTOfferingSettings } from "../features/qutoffering/offeringsettings/allactions"

import { SPCSymbolPC } from "../features/spcsymbolpc/allactions"
import { KPI } from "../features/kpi/allactions"

export let features = {
  SYSLogin,
  SYSShellbar,
  SYSUserAdministration,

  QUTBPFilter,
  QUTOffering,
  QUTOfferingPos,
  QUTOfferingAdminUpload,

  QUTOfferingDetails,
  QUTOfferingSettings,

  DATFeedback,
  DATSearchPaket,

  SPCSymbolPC,

  PKGPackaging,
  KPI,
}
